import React from 'react'
import { string } from 'prop-types'

import { Field } from 'redux-form'

import { Input, Avatar, Label } from './styles'

export const renderAvatarOption = props => (
  <Input
    {...props.input}
    name={props.name}
    onChange={() => props.input.onChange(props.input.value)}
    value={props.input.value}
    type="radio"
  />
)

function ChooseAvatarOption(props) {
  const { avatarUrl, name, value } = props

  return (
    <Label>
      <Field component={renderAvatarOption} name={name} type="radio" value={value} />
      <Avatar alt={`avatar type ${avatarUrl}`} src={avatarUrl} />
    </Label>
  )
}

ChooseAvatarOption.defaultProps = {
  avatarUrl: null
}

ChooseAvatarOption.propTypes = {
  avatarUrl: string.isRequired
}

export default ChooseAvatarOption



// WEBPACK FOOTER //
// ./src/app/elements/ChooseAvatarOption/ChooseAvatarOption.js